import { useLocation, matchPath } from 'react-router-dom';

/**
 * Determines the current tab based on the provided route patterns and the current pathname.
 *
 * @param {Array<string>} patterns - An array of route patterns to match against the current pathname.
 * @param {string} defaultTab - The default tab to return if no pattern matches.
 * @returns {string} The matched pattern's path or the default tab if no match is found.
 */
function useCurrentTab(patterns, defaultTab) {
  const { pathname } = useLocation();

  for (const pattern of patterns) {
    const match = matchPath(pattern, pathname);
    if (match) {
      return match.pattern.path;
    }
  }

  return defaultTab;
}

export default useCurrentTab;
